
<style lang="scss" scope>
.ivu-mt,
.ivu-mt-16 {
  margin-top: 16px !important;
}

.items-center {
  align-items: center;
}

.justify-between {
  justify-content: space-between;
}

.flex {
  display: flex !important;
  width: 100%;
}

.flex-warp {
  flex-wrap: wrap;
}

.mr1 {
  margin-right: 1rem;
  word-wrap: +break-word;
  word-break: +norm;
}

.flexs {
  display: flex !important;
  width: 15%;
}
</style>

<template>
  <el-card shadow="never" class="l-main-card">
    <div class="l-table-toolbar">

      <div class="flex flex-warp">
        <div class="flexs items-center ivu-mt ivu-mr">
          <l-auth-button type="primary" auth="Additional_add_btn" @click="add_visible = true"> 添加 2</l-auth-button>
          <l-auth-button type="primary" auth="Additional_add_btn" style="padding: 20px;" @click="Search"> 刷新</l-auth-button>
        </div>
        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">用户Id：</p>
          <el-input placeholder="请输入用户Id" v-model="search_data.app_user_id" class="input-with-select"
            style="width: 100%;">
            <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
          </el-input>
        </div>
        <div class="flexs items-center ivu-mt ivu-mr">
        <p class="mr1">员工名：</p>
        <el-input placeholder="请输入员工名" v-model="search_data.admin_name" class="input-with-select" style="width: 100%;">
          <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
        </el-input>
      </div>
        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">所属APP：</p>
          <div class="l-show-more-search">
            <el-select v-model="search_data.app_type" placeholder="全部" clearable @change="changes" style="width: 100%;">
              <el-option v-for="item in app_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>
        </div>

        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">状态：</p>
          <div class="l-show-more-search">
            <el-select v-model="search_data.state" placeholder="全部" clearable @change="changes" style="width: 100%;">
              <el-option v-for="item in state" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>
      </div>
      <div class="flexs items-center ivu-mt ivu-mr" >
          <l-auth-button  style="padding: 20px;" :loading="export_loading" type="primary" auth="batchAgree" @click="batchAgree(1)"> 批量通过 </l-auth-button>
          <l-auth-button  :loading="export_loading" type="primary" auth="batchReject" @click="batchAgree(2)"> 批量拒接 </l-auth-button>
        </div>
      </div>
    </div>
    <l-table :data="data" v-loading="loading" row-key="id" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55">
      </el-table-column>
      <el-table-column fixed prop="index" label="序号" width="80"> </el-table-column>

      <el-table-column prop="user_name" label="员工名" min-width="130" show-overflow-tooltip> </el-table-column>
      <!-- <el-table-column prop="app_user_id" label="用户ID" min-width="200" show-overflow-tooltip> </el-table-column> -->
      <el-table-column prop="DisplayId" label="用户显示ID" min-width="130" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="app_user_name" label="用户昵称" min-width="130" show-overflow-tooltip> </el-table-column>
      <!-- 
                  <el-table-column prop="picture" label="上传截图" min-width="260" show-overflow-tooltip> 
                    <template slot-scope="{ row }">
                      <my-img-component :images="row.picture" :width="60" :height="60"></my-img-component>
                    </template>        
                  </el-table-column> -->
      <el-table-column prop="state" label="状态" min-width="100" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <el-tag type="primary" size="small" disable-transitions v-if="row.state == 0">{{ ADDITI_STATE[row.state]
          }}</el-tag>
          <el-tag type="success" size="small" disable-transitions v-if="row.state == 1">{{ ADDITI_STATE[row.state]
          }}</el-tag>
          <el-tag type="danger" size="small" disable-transitions v-if="row.state == 2">{{ ADDITI_STATE[row.state]
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="startWith" label="起始自选号码" min-width="100" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="picture" label="'上传截图" min-width="160" show-overflow-tooltip>
        <div class="demo-image__preview" slot-scope="{ row }">
          <el-image style="width: 100px; height: 150px; padding: 2px;" v-for="(item, idx) in row.picture" :key="idx"
          :src="item" :preview-src-list="row.picture">
        </el-image>
          <!-- <el-image style="width: 100px; height: 150px; padding: 1px;" :src="url" :preview-src-list="srcList">
              </el-image> -->
        </div>
      </el-table-column>
   
      <el-table-column prop="code" label="激活码" min-width="150" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="days" label="有效期" min-width="100" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="length" label="长度（位）" min-width="80" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="choiceCount" label="可选靓号个数" min-width="80" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="effectiveStatus" label="是否已经激活" min-width="120" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <el-tag type="danger" size="small" disable-transitions v-if="row.effectiveStatus == 1">{{  STATE_NAMES[row.effectiveStatus] }}</el-tag>
          <el-tag type="success" size="small" disable-transitions v-if="row.effectiveStatus == 2">{{  STATE_NAMES[row.effectiveStatus] }}</el-tag>
          <el-tag size="danger"  disable-transitions v-if="row.effectiveStatus == 3">{{  STATE_NAMES[row.effectiveStatus] }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="use_at" label="使用时间" min-width="200" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="BeautifulAccount" label="用户选择靓号" min-width="200" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="created_at" label="申请提交时间" min-width="200" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="updated_at" label="审核时间" min-width="200" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="cause" label="同意/驳回理由" min-width="200" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="update_name" label="审核人" min-width="200" show-overflow-tooltip> </el-table-column>
     
      <el-table-column prop="app_id" label="归属平台" min-width="140" show-overflow-tooltip>
        <template slot-scope="{ row }">
          {{ APP_TYPE[row.app_id] }}
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" min-width="200" align="center">
        <template slot-scope="{ row }">
          <l-auth-text-button type="primary" auth="lottery_edit_btn" @click="showInfn(row.id)" v-if="row.state == 0"><i
              class="el-icon-edit"></i>通过</l-auth-text-button>
          <span class="l-action-separator"  v-if="row.state == 0">|</span>
          <l-auth-text-button type="danger" auth="lottery_del_btn" @click="showInfnS(row.id)" v-if="row.state == 0"><i
              class="el-icon-edit"></i>拒绝</l-auth-text-button>
        </template>
      </el-table-column>
    </l-table>

    <!--分页-->
    <l-page :total="count" @current-change="getList" @size-change="getList" :page-size.sync="page_size"
      :current-page.sync="page"></l-page>

    <!--详情-->
    <!-- <l-dialog :visible.sync="info_visible" title="详情" width="1200px">
                                  <l-logs-info :visible.sync="info_visible" :row="info_row" />
                                </l-dialog> -->
    <!--添加-->
    <l-dialog :visible.sync="add_visible" title="添加补录">
      <l-lottery-edit @on-success="onAddSucess" :visible.sync="add_visible"
        :id="list_id"></l-lottery-edit>
    </l-dialog>

    <l-dialog :visible.sync="info_visible" title="通过">
      <l-lottery-info @on-success="onInfoSucess" :visible.sync="info_visible" :id="list_id"
        :cz_state="cz_state"></l-lottery-info>
    </l-dialog>

    <l-dialog :visible.sync="info_s_visible" title="拒接">
      <l-lottery-info @on-success="onInfoSucess" :visible.sync="info_visible" :id="list_id"
        :cz_state="cz_state"></l-lottery-info>
    </l-dialog>

    <!-- <l-dialog :visible.sync="info_s_visible" title="查看">
      <l-lottery-info @on-success="onInfoSucess" :visible.sync="info_visible" :id="list_id"
        :cz_state="cz_state"></l-lottery-info>
    </l-dialog> -->

  </el-card>
</template>

<script>
import Edit from "./Edit";
import Vue from "vue";
import Info from "./Info";
import { APP_TYPE, ADDITI_STATE } from "../appUser/state";
import { STATE_NAMES_IS } from "@/common/constants/resources";
export default {
  components: {
    [Edit.name]: Edit,
    [Info.name]: Info,
  },
  data() {
    return {
      list_id: 0,
      cz_state: "",
      box: 1,
      data: [],
      count: 0,
      page: 1,
      page_size: Vue.$_config.page.page_size,
      loading: false,
      info_visible: false, //是否显示编辑
      info_s_visible: false,
      info_row: 0,
      APP_TYPE: APP_TYPE,
      STATE_NAMES:STATE_NAMES_IS,
      ADDITI_STATE: ADDITI_STATE,
      add_visible: false, //是否显示添加
      state: [
        {
          "id": 0,
          "name": "待审核"
        },
        {
          "id": 1,
          "name": "通过"
        },
        {
          "id": 2,
          "name": "拒绝"
        },
      ],
      //搜索
      search_visible: false,
      site_list: [],
      search_data: {
        app_user_id: "",
        admin_name: "",
        app_type: "",
        state: "",
      },
      rel_search_data: {},
      show_more_search: false,
      app_list: [
        {
          "id": 1,
          "name": "星伴"
        }
      ],
      accountRecordId:[]
    };
  },

  mounted() {
    this.getList();
  },

  methods: {
    Search(){
      this.$_invoke("adminUserLottery_refresh", {
      })
      this.getList();
    },
    handleSelectionChange(val) {
      val.map((item) => {
        //  this.accountRecordId 为自己定义的值
        this.accountRecordId.push(item.id)

      });
      console.log(this.accountRecordId);
    },
    batchAgree(key){
      // console.log('2222');
      if(this.accountRecordId.length == 0){
        this.$_msg.error('请选择操作对象！');
        
      }else{
        this.$confirm(
        "确定批量操作吗" + "？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.$_invoke(`adminUserLottery_update`, {id_arr: this.accountRecordId,key:key,cz_state:key}).then(() => {
            this.$_msg.success("操作成功");
            this.accountRecordId = [];
            this.getList();
          });
        })
        .catch(() => { });
      }
    
    },
  
    // 点击 更改部门
    changes() {
      this.getList();
    },
    //获取数据
    getList() {
      this.loading = true;
      this.$_invoke("adminUserLottery_getList", {
        page: this.page,
        page_size: this.page_size,
        ...this.search_data,
      })
        .then((ret) => {
          // console.log(444444444444444444444);
          // console.log(ret.data);
          this.data = ret.data;
          this.count = ret.count;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //点击搜索按钮
    onSearch() {
      this.page = 1;
      this.rel_search_data = this.search_data;
      this.getList();
    },

    //点击重置搜索框
    onReset() {
      this.$refs.search_form.resetFields();
      this.rel_search_data = {};
    },

    showInfn(id) {
      this.cz_state = 1;
      this.list_id = id;
      this.$nextTick(() => {
        this.info_visible = true;
      });
      // this.loading = true;
      // this.$_invoke("adminUserLottery_update", {
      //   "id":id,
      //   "key":1,
      //   "id_arr":this.accountRecordId
      // })
      //   .then((ret) => {
      //     console.log(ret);
      //     // this.data = ret.data;
      //     // this.count = ret.count;
      //   })
      //   .finally(() => {
      //     this.loading = false;
      //   });

    },






    showInfnS(id) {
      this.cz_state = 2;
      this.list_id = id;
      this.$nextTick(() => {
        this.info_s_visible = true;
      });
    },



    //操作
    showEdit(id) {
      this.list_id = id;
      this.$nextTick(() => {
        this.add_visible = true;
      });
    },

    // 和修改  添加成功回调
    onAddSucess() {
      this.add_visible = false;
      this.info_s_visible = false;
      this.getList();
    },

    onInfoSucess() {
      this.info_visible = false;
      this.info_s_visible = false;
      this.getList();
    },

    //清除搜索数据
    clearSearch() {
      this.search_data.app_user_id = "";
      this.search_data.admin_name = "";
      this.search_data.app_type = "";
      this.search_data.corp_id = "";
      this.search_data.depart_id = "";
      this.getList();
    },
  },
};
</script>
